// Module
var code = "<section class=\"content-section\"><div class=\"container\"><p>Reports: Coming soon!</p></div></section>\n";
// Exports
module.exports = code;